import { ToastrContext } from '@components/organisms/Toastr';
import { useContext } from 'react';

export function useNotifier() {
  const toastrContext = useContext(ToastrContext);

  return toastrContext;
}
